// extracted by mini-css-extract-plugin
module.exports = {"divFooter":"Footer_divFooter__2NXOK"};